import PropTypes from 'prop-types';

export const Input = ({ className = '', ...props }) => (
  <input
    className={`border border-gray-300 rounded-md px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-teal-500 ${className}`}
    {...props}
  />
);

Input.propTypes = {
  className: PropTypes.string,
};
